// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconiz {\n  padding: 5px; }\n  .iconiz-green {\n    color: #7bd812; }\n  .iconiz-rounded {\n    border-radius: 50%; }\n    .iconiz-rounded.solid {\n      background-color: #7bd812; }\n    .iconiz-rounded.regular {\n      background-color: white; }\n    .iconiz-rounded.border {\n      border: 1px solid;\n      border-color: #7bd812; }\n", ""]);
// Exports
module.exports = exports;
